module.exports = __webpack_public_path__ + "static/img/1.e64bfd2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/eng/1.png
// module id = w3p9
// module chunks = 0